import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { authApi } from "../api/resources.js";
import { useAuthStore } from "../stores/authStore.js";

export function ChangePin() {
  const staff = useAuthStore((state) => state.staff);
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  const [currentPin, setCurrentPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!staff) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async () => {
    setError(null);
    if (newPin !== confirmPin) {
      setError("新しいPIN（確認）が一致しません");
      return;
    }
    setSubmitting(true);
    try {
      await authApi.changePin(currentPin, newPin);
      // サーバー側のセッションは有効なままだが、ローカルのstaff情報を最新化するため
      // 一旦ログアウトし、新しいPINで改めてログインしてもらう。
      await logout();
      navigate("/login", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "PINの変更に失敗しました");
    } finally {
      setSubmitting(false);
    }
  };

  const canSubmit =
    currentPin.length >= 4 &&
    newPin.length >= 4 &&
    confirmPin.length >= 4 &&
    !submitting;

  return (
    <div
      className="app-shell"
      style={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <div className="card stack" style={{ width: 380 }}>
        <h1 style={{ textAlign: "center", fontSize: 20 }}>
          PINの変更が必要です
        </h1>
        <p
          style={{
            textAlign: "center",
            color: "var(--color-text-muted)",
            fontSize: 13.5,
          }}
        >
          初回ログイン、またはPINが初期値のままのため、続ける前に新しいPINを設定してください。
        </p>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="form-field">
          <label htmlFor="current-pin">現在のPIN</label>
          <input
            id="current-pin"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            maxLength={6}
            value={currentPin}
            onChange={(e) => setCurrentPin(e.target.value.replace(/\D/g, ""))}
          />
        </div>
        <div className="form-field">
          <label htmlFor="new-pin">新しいPIN（4〜6桁）</label>
          <input
            id="new-pin"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            maxLength={6}
            value={newPin}
            onChange={(e) => setNewPin(e.target.value.replace(/\D/g, ""))}
          />
        </div>
        <div className="form-field">
          <label htmlFor="confirm-pin">新しいPIN（確認）</label>
          <input
            id="confirm-pin"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            maxLength={6}
            value={confirmPin}
            onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, ""))}
          />
        </div>
        <button
          className="btn btn-primary btn-block btn-lg"
          disabled={!canSubmit}
          onClick={() => void handleSubmit()}
        >
          {submitting ? "変更中..." : "PINを変更する"}
        </button>
      </div>
    </div>
  );
}
